/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { Box, Button, Card, CardActionArea, CardContent, Paper, Stack, Typography } from "@mui/material";
import { customScrollbarStyle } from "../../../utils/Functions";
import { Effect, Nullable, Setter, StorageLocation } from "../../../utils/Interfaces";
import { NavigateBefore, Start } from "@mui/icons-material";
import React from "react";

export interface InventoryEgressModalProps {
    storageLocations: StorageLocation[];
    setSelectedStorageLocation: Setter<Nullable<StorageLocation>>;
    progressDialog: Effect;
    regressDialog?: Effect;
}

function StorageLocationSelector(props: InventoryEgressModalProps) {
    const { storageLocations, setSelectedStorageLocation, progressDialog, regressDialog } = props;

    return (
        <React.Fragment>
            <Box sx={{ mb: 2 }} />
            <Box
                sx={{
                    maxHeight: "calc(50vh)",
                    minHeight: "calc(50vh)",
                    overflowY: "auto",
                    overflowX: "hidden",
                    ...customScrollbarStyle(),
                }}
            >
                {storageLocations.map((storageLocation: StorageLocation, index: number) => {
                    return (
                        <Card
                            key={index}
                            component={Paper}
                            sx={{ mb: 1, mt: 1, mr: 1 }}
                            onClick={() => {
                                setSelectedStorageLocation(storageLocation);
                                progressDialog();
                            }}
                        >
                            <CardActionArea>
                                <CardContent>
                                    <Stack direction="row" justifyContent="space-between">
                                        <Typography>{storageLocation.name}</Typography>
                                        <Start />
                                    </Stack>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    );
                })}
            </Box>
            {regressDialog !== undefined && (
                <Button onClick={regressDialog} sx={{ mt: 10, mb: -2 }}>
                    <NavigateBefore />
                    &nbsp;Prev
                </Button>
            )}
            <Box sx={{ mb: regressDialog !== undefined ? 0 : 12.5 }} />
        </React.Fragment>
    );
}

export default StorageLocationSelector;
